import { Injectable, inject } from "@angular/core";
import { CanActivate } from "@angular/router";
import { LocaleService } from "src/app/services/locale.service";

@Injectable()
export class SyncLocaleWithTenantAvailableGuard implements CanActivate {
  private readonly localeService = inject(LocaleService);

  async canActivate(): Promise<boolean> {
    const localeToSet = await this.localeService.getLocaleWanted();

    await this.localeService.setLocale(localeToSet);

    console.log(
      `[SyncLocaleWithTenantAvailableGuard] localeToSet: ${localeToSet}`
    );

    return true;
  }
}
